export const ONBOARDING_CHECKLIST_COLLAPSED_KEY = "collapseOnboardingChecklist";

export const ONBOARDING_CHECKLIST_POSITION_KEY = "onboardingChecklistPosition";

export const ONBOARDING_CHECKLIST_TITLE = "Your BoomCRM onboarding checklist";

export const ONBOARDING_CHECKLIST_CTA_LABEL = "Manage";

export const ONBOARDING_CHECKLIST_PILL_BRAND = "BoomCRM";

export const ONBOARDING_CHECKLIST_PILL_LABEL = "Setup";

type ChecklistItemCopy = {
  description: string;
  breadcrumb?: string[];
};

// Copy-only; labels, routes and completion state come from the API.
export const ONBOARDING_CHECKLIST_COPY: Record<string, ChecklistItemCopy> = {
  property_branding: {
    description:
      "Set your company logo, colors and landlord contact so listings carry your branding — not a blank template — everywhere they get syndicated out to Zillow, Apartments.com, and other sites. Individual Communities can override it.",
    breadcrumb: ["Settings", "Branding"]
  },
  connect_syndication_feed: {
    description:
      "Publish your listings to sites like Zillow, Apartments.com, and Zumper automatically, instead of posting each one by hand.",
    breadcrumb: ["Settings", "Syndication"]
  },
  set_up_workflow: {
    description:
      "Automate a repeated step — like a welcome email to new leads — so it happens on its own instead of relying on someone to remember it."
  },
  default_listing_template: {
    description:
      "Create pre-screening questions, which buttons are shown, and define showing types on our listing template."
  },
  prescreening_criteria: {
    description:
      "Set minimum income, credit, and background requirements up front, so unqualified applicants are filtered out before your team spends time on them."
  },
  connect_email: {
    description:
      "Send and receive emails with leads and residents right inside the Inbox, instead of switching over to a separate email app."
  },
  connect_calendar: {
    description:
      "Keep tour bookings in sync with your team's real calendars, so a tour never gets double-booked."
  },
  configure_showing_availability: {
    description:
      "Let a lead book a tour with the right person, at a time they're actually free, without a back-and-forth phone call."
  },
  provision_phone_number: {
    description:
      "Give your team a dedicated number for calls and texts with leads and residents, tracked right alongside the conversation in the Inbox."
  },
  account_showing_settings: {
    description:
      "Configure when you send and receive showing notifications and how long showings are."
  },
  connect_sentrilock_codebox: {
    description:
      "Connect your SentriLock or Codebox account and import your lockboxes so you can start conducting self-guided showings."
  }
};
